/* Site-Specific JavaScript */
jq(document).ready(() => {
    // Client nav
    let body = document.body;
    let stock_quote_btn = document.getElementById('header-quote-toggle');
    let stock_quote = document.getElementById('header-stock-quote');
    let mobile_nav_toggle = document.getElementById('mobile-nav-toggle');
    stock_quote_btn.addEventListener('click', (evt) => {
        evt.preventDefault();
        body.classList.toggle('stockmarket-open');
        toggle_attribute(stock_quote_btn, 'aria-expanded');
        toggle_attribute(stock_quote, 'aria-hidden');
    });
    mobile_nav_toggle.addEventListener('click', (evt) => {
        body.classList.toggle('main-menu-open');
        toggle_attribute(mobile_nav_toggle, 'aria-expanded');
    });
    observeForContent('.menu-primary-navigation-container + .stockmarket .ticker-link')
        .then(() => {
            // Focus trap
            // Wait for QMOD to load
            let ticker_link = document.querySelector('.menu-primary-navigation-container + .stockmarket .ticker-link');
            mobile_nav_toggle.addEventListener('keydown', (evt) => {
                if (evt.shiftKey && evt.key === "Tab" && body.classList.contains('main-menu-open')) {
                    evt.preventDefault();
                    ticker_link.focus();
                }
            });
            ticker_link.addEventListener('keydown', (evt) => {
                if (!evt.shiftKey && evt.key === "Tab" && body.classList.contains('main-menu-open')) {
                    evt.preventDefault();
                    mobile_nav_toggle.focus();
                }
            });
        });
    // keep the scrolled state permanent if not on the homepage
    if (!body.classList.contains('page-type-ir-overview')) {
        body.classList.add('scrolled');
    }
    let debounce = false;
    document.addEventListener('scroll', () => {
        if (!debounce) {
            debounce = true;
            scroll_check();
            setTimeout(() => {
                debounce = false;
            }, 50);
        }
        if (window.scrollY == 0 && body.classList.contains('page-type-ir-overview')) {
            document.body.classList.remove('scrolled');
            document.body.classList.remove('scrolling-down');
        }
    });
    
    // Email Alert checkbox fix
    let ir_checkbox = document.getElementById('ir-sec-all');
    let ir_sub_boxes = document.querySelectorAll('.ir-sec-sub');
    if (ir_checkbox && ir_sub_boxes) {
        ir_checkbox.addEventListener('change', (evt) => {
            console.log(evt.target.checked);
            ir_sub_boxes.forEach((box) => {
                if (evt.target.checked) {
                    box.setAttribute('disabled', '');
                    box.setAttribute('checked', '');
                } else {
                    box.removeAttribute('disabled');
                    box.removeAttribute('checked');
                }
            });
        });
        if (ir_checkbox.checked) {
            ir_sub_boxes.forEach((box) => {
                box.setAttribute('disabled', '');
                box.setAttribute('checked', '');
            });
        }
    }
});

//OSANO cookie consent buttons
document.addEventListener('DOMContentLoaded', function () {
  var prefs = document.getElementById('osano-cookie-prefs');
  var dns   = document.getElementById('osano-do-not-sell');

  if (prefs) prefs.addEventListener('click', function (e) {
    e.preventDefault();
    if (window.Osano && Osano.cm) Osano.cm.showDrawer('osano-cm-dom-info-dialog-open');
  });

  if (dns) dns.addEventListener('click', function (e) {
    e.preventDefault();
    if (window.Osano && Osano.cm) Osano.cm.showDoNotSell();
  });
});

let last_scroll_pos = 0;
function scroll_check() {
    let body = document.body;
    if (window.scrollY > 0) {
        body.classList.add('scrolled');
    } else {
        if (body.classList.contains('page-type-ir-overview')) {
            body.classList.remove('scrolled');
        }
    }
    if (window.scrollY > last_scroll_pos && window.scrollY > 0) {
        if (body.classList.contains('page-type-ir-overview') || window.scrollY > 160) {
            body.classList.add('scrolling-down');
        }
    } else {
        body.classList.remove('scrolling-down');
    }
    last_scroll_pos = window.scrollY;
}

function toggle_attribute(el, attr) {
    el.setAttribute(attr, el.getAttribute(attr) !== 'true');
}

function observeForContent(selector) {
    return new Promise((resolve, reject) => {
        let checkInterval = setInterval(() => {
            if (jq(selector).html()) {
                clearInterval(checkInterval);
                resolve();
            }
        }, 100); // Check every 100 milliseconds
    });
}

//Accessibility fix: Tab trap on settings
document.addEventListener('DOMContentLoaded', function() {
    const openModalLink = jq('.cn-learn-more, #klaroPrefs');
    openModalLink.click(function(){
        const modal = jq('.cm-modal');
        modal.attr('tabindex', '0');

        setTimeout(() => {
            modal.focus();
            
            const focusableElements = 'a, button:not(.hide), input, textarea, select, details, [tabindex]:not([tabindex="-1"])';
            const firstFocusableElement = modal.find(focusableElements).first();
            const lastFocusableElement = modal.find(focusableElements).last();
            
            firstFocusableElement.on('keydown', function(e) {
                if (e.shiftKey && e.keyCode == 9){
                    e.preventDefault();
                    lastFocusableElement.focus();
                } 
            });
            lastFocusableElement.on('keydown', function(e) {
                if (!e.shiftKey && e.key === 'Tab') {
                    e.preventDefault();
                    firstFocusableElement.focus();
                }
            });
        }, 100); // Delay for the modal to open
    });
});
jq(document).ready(function() {
    // Select the target node to observe (body in this case)
    var observerTarget = jq('body')[0]; 

    // Create a new MutationObserver
    var observer = new MutationObserver(function(mutationsList) {
        mutationsList.forEach(function(mutation) {
            if (jq('.cky-modal').length) {
                jq('.cky-modal').attr({
                    'aria-label': 'Cookie Banner Modal',
                    'role': 'dialog'
                });
            }
            if (jq('.cky-consent-container').length) {
                jq('.cky-consent-container').attr({
                    'aria-label': 'Cookie Banner Banner',
                    'role': 'dialog'
                });
            }
            
        });
    });

    // Observer configuration
    var config = { childList: true, subtree: true };

    // Start observing the body for changes
    observer.observe(observerTarget, config);
});
function observeContent(selector, callback) {
    const observer = new MutationObserver(callback);
    document.querySelectorAll(selector).forEach(el => {
        observer.observe(el, { childList: true, subtree: true });
    });
}

// Initial check and observe changes
function updateAccessibility() {
    if (jq(".sui-layout-header").length) {
        jq("form, input").removeAttr("role aria-expanded aria-labelledby");
        jq("input").attr("aria-label", "Search");
    }
}

// Run on load
jq(document).ready(updateAccessibility);

// Observe DOM changes
observeContent("body", updateAccessibility);